module.exports = "./dist/asset/loading.svg";